import { render, staticRenderFns } from "./PreviousProfileFound.vue?vue&type=template&id=71a2787f&scoped=true&"
import script from "./PreviousProfileFound.vue?vue&type=script&lang=js&"
export * from "./PreviousProfileFound.vue?vue&type=script&lang=js&"
import style0 from "./PreviousProfileFound.vue?vue&type=style&index=0&id=71a2787f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a2787f",
  null
  
)

export default component.exports